import type {
  CampaignChannelFilter,
  CampaignDisplayStatus,
  CampaignsSortKey,
  CampaignType,
} from '../types/campaigns.types';

export const CAMPAIGN_DISPLAY_STATUS_OPTIONS: {
  value: CampaignDisplayStatus;
  label: string;
}[] = [
  { value: 'Draft', label: 'Draft' },
  { value: 'Scheduled', label: 'Scheduled' },
  { value: 'Sending', label: 'Sending' },
  { value: 'Sent', label: 'Sent' },
  { value: 'Failed', label: 'Failed' },
  { value: 'Cancelled', label: 'Cancelled' },
];

export const CAMPAIGNS_SORT_OPTIONS: {
  value: CampaignsSortKey;
  label: string;
}[] = [
  { value: 'updatedAt', label: 'Last updated' },
  { value: 'createdAt', label: 'Created (newest)' },
  { value: 'createdAtAsc', label: 'Created (oldest)' },
  { value: 'name', label: 'Name (A–Z)' },
  { value: 'scheduledAt', label: 'Scheduled/sent time' },
];

export const CAMPAIGN_CHANNEL_FILTER_OPTIONS: { value: CampaignChannelFilter; label: string }[] = [
  { value: 'all', label: 'All channels' },
  { value: 'email', label: 'Email' },
  { value: 'sms', label: 'SMS' },
];

export const CAMPAIGNS_PAGE_SIZE_OPTIONS = [10, 25, 50] as const;

export const CAMPAIGN_TYPE_OPTIONS: { value: CampaignType | 'all'; label: string }[] = [
  { value: 'all', label: 'All Types' },
  { value: 'Regular', label: 'Regular' },
  { value: 'Scheduled', label: 'Scheduled' },
  { value: 'Recurring', label: 'Recurring' },
];

export const CAMPAIGN_TYPE_STYLES: Record<CampaignType, { bg: string; text: string }> = {
  Regular: {
    bg: '#E8F2FA',
    text: '#0066B2',
  },
  Scheduled: {
    bg: '#EEE8F8',
    text: '#7B61C4',
  },
  Recurring: {
    bg: '#E8F8EF',
    text: '#1B7A4A',
  },
};

/** Default sender identity for new campaigns (Details step). */
export const DEFAULT_CAMPAIGN_FROM_NAME = 'Selise Blocks';
export const DEFAULT_CAMPAIGN_FROM_EMAIL = 'blocks@selise.io';
export const DEFAULT_CAMPAIGN_REPLY_TO = 'blocks@selise.io';
